import { useQuery, useQueryClient, useMutation } from 'react-query';
import { getBlogDetails, blogRating, getComments, postComment, rateComment, deleteComment } from '../../api/details';


export const BLOG_QUERY_KEY = 'blog-';

export const useGetBlogDetails = (slug) => {
    const query = useQuery(BLOG_QUERY_KEY + slug, async () => getBlogDetails(slug), {
        refetchOnWindowFocus: false,
        enabled: !!slug, 
    });
    return query;
};

export const useBlogRating = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation(({ params}: { params: any}) => blogRating({params}));
    return {
        blogRating: async (params) => {
            await mutation.mutateAsync({params});
            queryClient.invalidateQueries(BLOG_QUERY_KEY + params.post);
        },
        error: mutation.isError,
        loading: mutation.isLoading,
    };
};

export const useGetComments = (slug) => {
    const query = useQuery(BLOG_QUERY_KEY + "comments-" + slug , async () => getComments(slug), {
        refetchOnWindowFocus: false,
    });
    return query;
};

export const usePostComment = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation(({ params }: { params: any }) => postComment({ params }));
    return {
        postComment: async ( params) => {
            await mutation.mutateAsync({ params });
            queryClient.invalidateQueries(BLOG_QUERY_KEY + "comments-" + params.post);
        },
        error: mutation.isError,
        loading: mutation.isLoading,
    };
};
export const useRateComment = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation(({ params }: { params: any }) => rateComment({params }));
    return {
        rateComment: async (params) => {
            await mutation.mutateAsync({ params });
            queryClient.invalidateQueries(BLOG_QUERY_KEY + "comments-" + params.slug);
        },
        isError: mutation.isError,
        loading: mutation.isLoading,
    };
};

export const useDeleteComment = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation(({ params }: { params: any }) => deleteComment({params }));
    return {
        deleteComment: async (params) => {
            await mutation.mutateAsync({ params });
            queryClient.invalidateQueries(BLOG_QUERY_KEY + "comments-" + params.slug);
        },
        error: mutation.isError,
        loading: mutation.isLoading,
    };
};



